import React from 'react';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
export function RiskReversal() {
  return <section className="section-spacing bg-gradient-warm" data-id="element-490">
      <div className="container-narrow" data-id="element-491">
        <div className="bg-gradient-to-br from-accent-success/10 to-accent-success/5 border-2 border-accent-success/30 rounded-2xl p-6 md:p-8 shadow-large" data-id="element-492">
          <div className="text-center mb-6" data-id="element-493">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-accent-success rounded-xl mb-4 shadow-medium" data-id="element-494">
              <ShieldCheckIcon className="w-10 h-10 text-white" data-id="element-495" />
            </div>
            <h2 className="text-2xl sm:text-3xl font-black text-deep-cocoa mb-3" data-id="element-496">
              Garantía 100% Sin Riesgos
            </h2>
            <p className="text-lg text-deep-cocoa/80 font-semibold" data-id="element-497">
              30 días para probar. Si no te gusta, te devolvemos todo.
            </p>
          </div>

          <div className="bg-white rounded-xl p-5 md:p-6 mb-6 shadow-soft" data-id="element-498">
            <p className="text-base text-deep-cocoa leading-relaxed mb-3" data-id="element-499">
              Tienes{' '}
              <strong className="text-accent-success text-xl" data-id="element-500">
                30 días completos
              </strong>{' '}
              para probar la guía y ver resultados.
            </p>

            <p className="text-base text-deep-cocoa leading-relaxed mb-4" data-id="element-501">
              Si no estás satisfecha, te devolvemos{' '}
              <strong className="text-accent-success" data-id="element-502">cada peso</strong>. Sin
              preguntas.
            </p>

            <div className="bg-accent-success/10 rounded-lg p-4 border border-accent-success/20" data-id="element-503">
              <p className="text-lg font-bold text-deep-cocoa text-center" data-id="element-504">
                El riesgo es 100% mío. Tú no pierdes nada.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-505">
            {[{
            title: 'Devolución 24h',
            desc: 'Reembolso inmediato'
          }, {
            title: 'Sin preguntas',
            desc: 'No justificas nada'
          }, {
            title: '30 días',
            desc: 'Tiempo suficiente'
          }, {
            title: '100% dinero',
            desc: 'Cada peso'
          }].map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-506">
                <CheckIcon className="w-5 h-5 text-accent-success flex-shrink-0 mt-0.5" data-id="element-507" />
                <div data-id="element-508">
                  <h3 className="font-bold text-deep-cocoa text-sm mb-0.5" data-id="element-509">
                    {item.title}
                  </h3>
                  <p className="text-xs text-deep-cocoa/70" data-id="element-510">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}